import React from 'react';
import { observer } from 'mobx-react';
import {
  Box, Button, Grid,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Trans } from '@gamiphy/react-i18n';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { Popup } from '@gamiphy/loyalty-station-desktop/components/popup';
import WelcomeGift from '@gamiphy/icons/WelcomeGift';
import { SdkStore } from '@gamiphy/loyalty-station-desktop/store/sdk';

export type Props = {
  title: string,
  open: boolean,
  onClose: () => void,
};

const UnavowedPopup: React.FC<Props> = observer(({ title, open, onClose }) => {
  const theme = useTheme();
  const popupImage = ThemeStore.getImageUrl('unavowedPopupImage', '');

  return (
    <Popup fullWidth open={open} onClose={onClose}>
      <Grid container alignItems="center">
        <Grid
          container
          sx={{
            background: theme.palette.primary.main, color: '#fff', fontWeight: 600, width: '100%',
          }}
        >
          <Grid
            sx={{
              fontWeight: 500,
              padding: theme.spacing(2),
              paddingTop: { xs: '22%', md: '22%' },
              paddingBottom: { xs: '22%', md: '22%' },
              color: theme.palette.text.secondary,
              '@media (max-height: 600px)': {
                padding: theme.spacing(2),
                paddingTop: '10%',
                paddingBottom: '10%',
              },
            }}
            size={6}
          >
            {title}
          </Grid>
          {popupImage ? (
            <Grid
              sx={{
                width: '100%',
                backgroundImage: `url(${popupImage})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
              size={6}
            />
          ) : (
            <Grid size={6} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <WelcomeGift width="110px" height="110px" color={ThemeStore.theme.palette?.text?.secondary} />
            </Grid>
          )}
        </Grid>
        <Grid size={12}>
          <Box sx={{
            padding: theme.spacing(3, 1),
            background: '#fff',
            display: 'grid',
            gap: theme.spacing(2),
            justifyItems: 'center',
          }}
          >
            {AppStore.app.logo && (
              <img
                src={AppStore.app.logo}
                alt={AppStore.app.name ?? ''}
                style={{ maxWidth: '75%', maxHeight: '5.5rem' }}
              />
            )}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => void SdkStore.goToAuth(true)}
            >
              <Trans
                i18nKey="unavowedPopup.SignUpButton"
                defaults="Sign up in {{appName}}"
                values={{
                  appName: AppStore.app.name,
                }}
              />
            </Button>
            <Box sx={{ textAlign: 'center', '& > button': { fontWeight: 600 } }}>
              <Trans
                i18nKey="unavowedPopup.signInText"
                defaults="Already a friend enjoying benefits? <signIn>Sign in</signIn>"
                components={{
                  signIn: (
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => void SdkStore.goToAuth(false)}
                    />
                  ),
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Popup>
  );
});

export default UnavowedPopup;
